import React from "react";
import { Form, Input, Button, Upload, message } from "antd";
import { LeftOutlined, UploadOutlined, LinkOutlined } from "@ant-design/icons";
import { useSmartBack } from "../../utils/useSmartBack";
import PageLogoutButton from "../../Components/PageLogoutButton";

const Admin = () => {
  const smartBack = useSmartBack();
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Success:", values);
    // message.success("Profile updated successfully!");
  };

  return (
    <div className="p-8 bg-slate-50 min-h-screen">
      {/* 1. Header with Back Button */}
      <div className="flex justify-between items-center gap-3 mb-6">
        <div className="flex items-center gap-3">
          <Button
            icon={<LeftOutlined />}
            className="flex items-center justify-center rounded-md border-gray-200"
            onClick={smartBack}
          />
          <h1 className="text-xl font-normal text-gray-700">Profile</h1>
        </div>
        <PageLogoutButton />
      </div>

      {/* 2. Main White Card Container */}
      <div className="bg-white rounded-[24px] border border-gray-200 p-12 shadow-sm max-w-6xl mx-auto">
        <Form
          form={form}
          layout="horizontal"
          colon={false}
          onFinish={onFinish}
          labelAlign="left"
          // This creates the side-by-side layout (6 parts label, 14 parts input)
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 14 }}
          requiredMark={false} // Shows the red asterisk
          className="max-w-4xl"
        >
          {/* Site Name */}
          <Form.Item
            label={
              <span className="text-gray-600 font-medium text-base">
                Site Name
                <span className="text-red-500 align-top text-xs">*</span>
              </span>
            }
            name="siteName"
            rules={[{ required: true, message: "Please input site name!" }]}
          >
            <Input
              placeholder="Alliance Test Equipment Inc."
              className="Allinput"
            />
          </Form.Item>

          {/* Tel Number */}
          <Form.Item
            label={
              <span className="text-gray-600 font-medium text-base">
                Tel Number
                <span className="text-red-500 align-top text-xs">*</span>
              </span>
            }
            name="telNumber"
            rules={[{ required: true, message: "Please input tel number!" }]}
          >
            <Input placeholder="508-671-9970" className="Allinput" />
          </Form.Item>

          {/* Address */}
          <Form.Item
            label={
              <span className="text-gray-600 font-medium text-base">
                Address
                <span className="text-red-500 align-top text-xs">*</span>
              </span>
            }
            name="address"
            rules={[{ required: true, message: "Please input address!" }]}
          >
            <Input.TextArea
              placeholder="USA"
              rows={3}
              style={{ resize: "none" }}
              className="rounded-lg py-2"
            />
          </Form.Item>

          {/* About Us */}
          <Form.Item
            label={
              <span className="text-gray-600 font-medium text-base">
                About Us
                <span className="text-red-500 align-top text-xs">*</span>
              </span>
            }
            name="aboutUs"
            rules={[{ required: true, message: "Please input about us!" }]}
          >
            <Input.TextArea
              placeholder="Admin"
              rows={3}
              style={{ resize: "none" }}
              className="rounded-lg py-2"
            />
          </Form.Item>

          {/* Logo Upload */}
          <Form.Item
            label={
              <span className="text-gray-600 font-medium text-base">
                Logo
                <span className="text-red-500 align-top text-xs">*</span>
              </span>
            }
            name="logo" // 1. Added name
            valuePropName="fileList" // 2. Tells Form to track 'fileList'
            getValueFromEvent={(e) => {
              // 3. Standard AntD helper to extract file list
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
            rules={[{ required: true, message: "Please upload a logo!" }]}
          >
            <div className="flex flex-col gap-3">
              <Upload maxCount={1} beforeUpload={() => false}>
                {" "}
                {/* beforeUpload returns false to prevent auto-uploading to a server immediately */}
                <Button
                  icon={<UploadOutlined />}
                  className="rounded-lg h-10 px-6"
                >
                  Upload
                </Button>
              </Upload>
              <LinkOutlined className="text-gray-400 text-lg w-fit cursor-pointer" />
              <div className="border border-gray-200 rounded-xl p-4 w-fit bg-white">
                <img
                  src={require("../../Assets/logo.png")}
                  alt="Logo Preview"
                  className="h-12 object-contain"
                />
              </div>
            </div>
          </Form.Item>

          {/* Favicon Upload */}
          <Form.Item
            label={
              <span className="text-gray-600 font-medium text-base">
                Favicon
                <span className="text-red-500 align-top text-xs">*</span>
              </span>
            }
            name="favicon" // 1. Added name
            valuePropName="fileList" // 2. Tells Form to track 'fileList'
            getValueFromEvent={(e) => {
              // 3. Helper
              if (Array.isArray(e)) return e;
              return e?.fileList;
            }}
            rules={[{ required: true, message: "Please upload a favicon!" }]}
          >
            <div className="flex flex-col gap-3">
              <Upload maxCount={1} beforeUpload={() => false}>
                <Button
                  icon={<UploadOutlined />}
                  className="rounded-lg h-10 px-6"
                >
                  Upload
                </Button>
              </Upload>
              <LinkOutlined className="text-gray-400 text-lg w-fit cursor-pointer" />
              <div className="border border-gray-200 rounded-xl p-4 w-20 h-20 flex items-center justify-center bg-white">
                <img
                  src={require("../../Assets/logo.png")}
                  alt="Favicon"
                  className="w-12 h-12 object-contain"
                />
              </div>
            </div>
          </Form.Item>

          {/* Submit Button Container */}
          <div className="flex justify-end mt-10">
            <Button
              type="primary"
              htmlType="submit"
              className="bg-[#004aad] hover:bg-blue-800 h-10 px-10 rounded-lg border-none text-white font-medium"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default Admin;
